import { render, staticRenderFns } from "./PCInformationCard.vue?vue&type=template&id=2dda8ab6&scoped=true"
import script from "./PCInformationCard.vue?vue&type=script&lang=ts"
export * from "./PCInformationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda8ab6",
  null
  
)

/* custom blocks */
import block0 from "./PCInformationCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports